import { encodeFacebookUserId, facebookLogin, getGoogleLoginParams, googleLogin } from "@services/vueCustomerSvc";
import { mapActions, mapMutations } from 'vuex';
import { getObjProperty } from "@utilities/mrVueUtils";

export default {
  async mounted() {
    this.initGoogleAuthInstance();
  },

  methods: {
    ...mapActions(['notify']),

    ...mapActions('signIn', [
      'afterSignin'
    ]),

    ...mapMutations('signIn', [
      'setGoogleLoading',
    ]),

    mix_facebookSignIn() {
      let FB = window.FB;

      if (!FB) {
        setTimeout(this.mix_facebookSignIn(), 300);
        return;
      }

      FB.login((loginRes) => {
        encodeFacebookUserId(loginRes).then(() => {
          let fields = [
            "id",
            "email",
            "name",
            "first_name",
            "last_name",
            "middle_name",
            "gender",
            "birthday",
            "hometown",
            "link",
            "locale",
            "location",
            "timezone",
            "updated_time",
            "verified"
          ];

          FB.api("/me", { fields: fields.join(",") }, fbRes => {
            FB.getLoginStatus(statusRes => {
              if (statusRes.authResponse && statusRes.authResponse.accessToken && statusRes.authResponse.expiresIn) {
                fbRes.accessToken = statusRes.authResponse.accessToken;
                fbRes.accessTokenExpires = statusRes.authResponse.expiresIn;
              }

              facebookLogin(fbRes).then(res => {
                if (res.data.success == 0 && res.data.err == "bad-facebook-data") {
                  return this.mix_notifyFacebookSignInError();
                }

                this.afterSignin();
              }).catch(() => {
                this.mix_notifyFacebookSignInError();
              });
            });
          });
        }).catch(() => {
          this.mix_notifyFacebookSignInError();
        });
      }, {
        scope: ['email'].join(','),
        return_scopes: true
      });
    },

    mix_notifyFacebookSignInError() {
      this.notify({
        message: "There was a problem retrieving your data from facebook. Please submit an email and password to log in or create an account.",
        time: 15000
      });
    },

    getGoogleContainerWidth () {
      /** Default width as Google Maximum */
      let googleMaxWidth = 400;
      let width;
      try {
        if (window.document && window.document.querySelector('#google-sign-in-container')) {
          width = window.document.querySelector('#google-sign-in-container').offsetWidth;
        }
      } catch (error) {
        width = googleMaxWidth;
      }

      return width;
    },

    async initGoogleAuthInstance () {
      const googleContainerWidth = this.getGoogleContainerWidth();
      const gai = getObjProperty(window, 'google.accounts.id');

      if (!gai) {
        setTimeout(this.initGoogleAuthInstance, 300);
        return;
      }

      if (!window.googleInitialized) {
        const response = await getGoogleLoginParams();
        const googleSignInData = response.data;

        gai.initialize({
          client_id: googleSignInData.client_id,
          callback: this.handleGoogleCallback,
          context: 'signin'
        });

        window.googleInitialized = true;
      }

      gai.renderButton(
        window.document.getElementById("google-sign-in-btn"),
        { theme: "outline", size: "large", width: googleContainerWidth, text: 'continue_with' }
      );
    },

    async handleGoogleCallback(data) {
      this.setGoogleLoading(true);
      const token = data.credential;

      await googleLogin({ token });
      this.afterSignin();
    },

    async mix_googleSignIn() {
      window.google.accounts.id.prompt();
    },

    mix_notifyGoogleSignInError() {
      this.notify({
        message: "There was a problem retrieving your data from Google. Please submit an email and password to log in or create an account.",
        time: 15000
      });
    }
  }
};
